import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Wrench } from '@phosphor-icons/react';

const SCOPE_COLOR = {
  patient: 'bg-blue-100 text-blue-700 hover:bg-blue-200 border-blue-200',
  employee: 'bg-violet-100 text-violet-700 hover:bg-violet-200 border-violet-200',
  agency: 'bg-amber-100 text-amber-700 hover:bg-amber-200 border-amber-200',
  claim: 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200 border-emerald-200',
};

const FixFieldButton = ({ fix }) => {
  const navigate = useNavigate();
  if (!fix || !fix.path) return null;
  const handleClick = () => {
    const params = new URLSearchParams(fix.query || {}).toString();
    navigate(params ? `${fix.path}?${params}` : fix.path);
  };
  const scopeColor =
    SCOPE_COLOR[fix.scope || 'patient'] ||
    'bg-slate-100 text-slate-700 hover:bg-slate-200 border-slate-200';
  return (
    <button
      type="button"
      onClick={handleClick}
      className={`mt-1.5 inline-flex items-center gap-1.5 text-[11px] font-medium px-2 py-1 rounded border transition-colors ${scopeColor}`}
      data-testid={`fix-field-btn-${fix.scope || 'unknown'}`}
    >
      <Wrench size={11} weight="fill" />
      {fix.label}
    </button>
  );
};

export default FixFieldButton;
